import { useContext } from 'react';
import { LoyaltyMembershipDetailsContext } from '../contexts/loyalty-membership-details-context';
export const useLoyaltyMembershipDetails = () => {
    const context = useContext(LoyaltyMembershipDetailsContext);
    if (!context) {
        throw new Error('useLoyaltyMembershipDetails must be used within LoyaltyMembershipDetailsProvider');
    }
    return context;
};
